import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { DataPickerComponent } from './data-picker.component';
import { CustomerDataPickerModule } from './customer-data-picker/customer-data-picker.module';
import { QuickCreateCustomerModule } from './quick-create-customer/quick-create-customer.module';
import { OrganizationDataPickerModule } from './organization-data-picker/organization-data-picker.module';
import { QuickCreateOrganizationModule } from './quick-create-organization/quick-create-organization.module';
import { PropertyDataPickerModule } from './property-data-picker/property-data-picker.module';
import { QuickCreatePropertyModule } from './quick-create-property/quick-create-property.module';
import { AssetDataPickerModule } from './asset-data-picker/asset-data-picker.module';
import { ContractDataPickerModule } from './contract-data-picker/contract-data-picker.module';
import { JobDataPickerModule } from './job-data-picker/job-data-picker.module';
import { QuoteDataPickerModule } from './quote-data-picker/quote-data-picker.module';
import { QuickCreateAssetModule } from './quick-create-asset/quick-create-asset.module';
import { ServiceDataPickerModule } from './service-data-picker/service-data-picker.module';
import { RequestDataPickerModule } from './request-data-picker/request-data-picker.module';
import { ProjectDataPickerModule } from './project-data-picker/project-data-picker.module';
import { InvoiceDataPickerComponent } from './invoice-data-picker/invoice-data-picker.component';
import { InvoiceDataPickerModule } from './invoice-data-picker/invoice-data-picker.module';

@NgModule({
  declarations: [
    DataPickerComponent
  ],
  imports: [
    SharedModule,
    CustomerDataPickerModule,
    QuickCreateCustomerModule,
    OrganizationDataPickerModule,
    QuickCreateOrganizationModule,
    PropertyDataPickerModule,
    QuickCreatePropertyModule,
    AssetDataPickerModule,
    QuickCreateAssetModule,
    ContractDataPickerModule,
    JobDataPickerModule,
    QuoteDataPickerModule,
    ServiceDataPickerModule,
    RequestDataPickerModule,
    ProjectDataPickerModule,
    InvoiceDataPickerModule
  ],
  exports:[
    DataPickerComponent
  ]
})
export class DataPickerModule { }
